import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  border: PropTypes.bool,
};

const defaultProps = {
  required: false,
  onChange: null,
  value: '',
  className: '',
  border: false,
};

const TextArea = props => {
  const { name, id, placeholder, onChange, required, value, className } = props;

  return (
    <textarea
      {...props}
      className={clsx(
        'h-24 overflow-auto appearance-none block w-full py-1.5 px-2 text-gray-800 rounded border-none shadow-input focus:shadow-input-focus',
        className,
      )}
      name={name}
      id={id}
      placeholder={placeholder}
      onChange={onChange ? e => onChange(e) : null}
      required={required}
      value={value || null}
    />
  );
};

TextArea.propTypes = propTypes;
TextArea.defaultProps = defaultProps;

export default TextArea;
